var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5e3d9fda5b5dc177df783a0837008eefe6e105c0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tours@smartrent"]={id:"5e3d9fda5b5dc177df783a0837008eefe6e105c0"};
      